module.exports = __webpack_public_path__ + "static/id_card_back.1e65efbe.png";